var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 925,
    viewBox: "0 0 468 925",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467.219 462.5H0c-.005-60.735 12.077-120.876 35.555-176.989 23.478-56.112 57.893-107.098 101.278-150.046 43.386-42.947 94.893-77.015 151.581-100.258C345.102 11.963 405.86 0 467.219 0v462.5zM467.219 925H0c-.005-60.735 12.077-120.876 35.555-176.989 23.478-56.112 57.893-107.098 101.278-150.046 43.386-42.947 94.893-77.015 151.581-100.258C345.102 474.463 405.86 462.5 467.219 462.5V925z",
    fill: "#fff"
  })));
}
export default SvgOnboardingIllustration;